import React from 'react';
import { useNavigate } from 'react-router-dom';
import Seo from '../components/common/Seo';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
      {/* The SPA answers 200 OK for every unknown path, so without this a
          crawler treats an unlimited number of broken URLs as real pages — all
          of them duplicates of the homepage. noindex is what Google documents
          for a soft 404 that cannot return a real status code. */}
      <Seo title="Page Not Found — Kynaix Sports" noindex />
      <h1 className="text-8xl font-bold text-gray-300 mb-4">404</h1>
      <h2 className="text-2xl font-semibold mb-2">Page Not Found</h2>
      <p className="text-gray-500 mb-8">The page you're looking for doesn't exist.</p>
      <button
        onClick={() => navigate('/')}
        className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
      >
        Go Home
      </button>
    </div>
  );
};

export default NotFoundPage;
